module.exports = __webpack_public_path__ + "img/Fb.7957e37f.svg";